// extracted by mini-css-extract-plugin
export var circle = "_2f-2";
export var icon = "_2f-a";
export var iconHighlight = "_2f-0";
export var lg = "_2f-8";
export var md = "_2f-7";
export var outline = "_2f-4";
export var sm = "_2f-6";
export var square = "_2f-1";
export var xl = "_2f-9";
export var xs = "_2f-5";
export var xxs = "_2f-3";